import * as Yup from 'yup'

const TITLE_MAX_LENGTH = 120
const DESCRIPTION_MAX_LENGTH = 4000

export const CreateOpportunitySchema = Yup.object().shape({
  title: Yup.string()
    .required('Title is required')
    .max(TITLE_MAX_LENGTH, `The maximum length allowed is ${TITLE_MAX_LENGTH}`),
  description: Yup.string()
    .required('Description is required')
    .max(DESCRIPTION_MAX_LENGTH, `The maximum length allowed is ${DESCRIPTION_MAX_LENGTH}`),
  // The market set is fixed at creation and cannot be changed afterwards, so at least one is required here.
  partnerMarketIds: Yup.array()
    .of(Yup.string())
    .min(1, 'Pick at least one market')
    .required('Pick at least one market'),
})
